import { EltType } from 'legacy/lut/classes/models/partner360/ELT/EltType'
import {
  competitorsSnapshotDocOctoberKeys,
  competitorsSnapshotKeys,
  TCompetitorsSnapshot,
  TCompetitorsSnapshotKeys,
} from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'
import { ICompetitor } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'

import { formCompetitorsFromFinancialData } from '../../ui/financialSnapshot/competitors/formCompetitorsFromFinancialData'

export const forceUpdateCompetitors = (
  competitorsFromFinancialData: TCompetitorsSnapshot,
  competitorsFromForm: ICompetitor[],
  eltType: EltType
) => {
  const snapshotKeys: readonly TCompetitorsSnapshotKeys[] =
    eltType === EltType.DocOctober25 || eltType === EltType.DocJanuary26
      ? competitorsSnapshotDocOctoberKeys
      : competitorsSnapshotKeys

  const competitors = snapshotKeys.reduce((acc, key) => {
    const hpData = competitorsFromFinancialData[key].filter((el) => el.Name === 'HP')
    const otherData =
      competitorsFromForm
        .find((el) => el.Category === key)
        ?.Competitors?.filter((el) => el.Name !== 'HP') || []
    return { ...acc, [key]: [...hpData, ...otherData] }
  }, {} as TCompetitorsSnapshot)

  return formCompetitorsFromFinancialData(competitors, snapshotKeys)
}
